module.exports = __webpack_public_path__ + "static/media/allowArr.101f56dc.svg";